import { action, makeObservable, observable } from 'mobx'

class PolicyStore {
    constructor(parentStore) {
        this.parentStore = parentStore

        this.policyId = null
        this.policyNumber = null
        this.insuredName = null
        this.insuranceCompany = null
        this.riskType = null
        this.asset = null
        this.validFrom = null
        this.validTo = null
        this.documents = []

        makeObservable(this, {
            policyId: observable,
            policyNumber: observable,
            insuredName: observable,
            insuranceCompany: observable,
            riskType: observable,
            asset: observable,
            validFrom: observable,
            validTo: observable,
            documents: observable,
            setPolicyData: action,
            applyFromInspectionPolicy: action,
            clearPolicyData: action,
        })
    }

    setPolicyData(value = {}) {
        this.policyId = value?.id ?? value?.policyId ?? null
        this.policyNumber = value?.policyNumber ?? null
        this.insuredName = value?.insuredName ?? null
        this.insuranceCompany = value?.insuredCompany ?? value?.insuranceCompany ?? null
        this.riskType = value?.riskType ?? null
        this.asset = value?.asset ?? value?.assetDescription ?? null
        this.validFrom = value?.validFrom ?? null
        this.validTo = value?.validTo ?? null
        this.documents = value?.documents ?? []
    }

    /** Fragmento `policy` devuelto por la API de inspección (cabecera en pantalla). */
    applyFromInspectionPolicy(policy) {
        this.insuredName = policy?.insuredFullName
        this.insuranceCompany = policy?.insuredCompany
        this.riskType = policy?.riskType ?? null
        this.asset = policy?.asset
        this.validFrom = policy?.validFrom
        if (policy && 'validTo' in policy) {
            this.validTo = policy.validTo
        }
    }

    clearPolicyData() {
        this.policyId = null
        this.policyNumber = null
        this.insuredName = null
        this.insuranceCompany = null
        this.riskType = null
        this.asset = null
        this.validFrom = null
        this.validTo = null
        this.documents = []
    }
}

export default PolicyStore
